import { useQuery } from "@tanstack/react-query";
import {
  type EntityListOfFollowerDto,
  type EntityListOfSocialUserSummary,
  getSocialFollowers,
  getSocialFollows,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { SOCIAL_LIST_PAGE_SIZE } from "Pages/People/constants";

export const followsKeys = {
  all: ["SOCIAL_FOLLOWS"] as const,
  followed: (pageNumber: number) =>
    [...followsKeys.all, "followed", pageNumber] as const,
  followers: (pageNumber: number) =>
    [...followsKeys.all, "followers", pageNumber] as const,
};

/** A page of the personas the caller follows. */
export const useFollowedUsersQuery = (pageNumber = 1) =>
  useQuery<EntityListOfSocialUserSummary>({
    queryKey: followsKeys.followed(pageNumber),
    queryFn: processResponseWithApiProblemDetails(() =>
      getSocialFollows(SOCIAL_LIST_PAGE_SIZE, pageNumber),
    ),
  });

/**
 * A page of the personas following the caller, each with the caller's side of the pair (already
 * followed back, follow-back requested, or whether following back needs their approval).
 */
export const useFollowersQuery = (pageNumber = 1) =>
  useQuery<EntityListOfFollowerDto>({
    queryKey: followsKeys.followers(pageNumber),
    queryFn: processResponseWithApiProblemDetails(() =>
      getSocialFollowers(SOCIAL_LIST_PAGE_SIZE, pageNumber),
    ),
  });
